var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","disabled":!_vm.$store.state.qlik.contextualHelp || !_vm.objectDescription,"max-width":"400px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({staticClass:"pa-3"},'div',attrs,false),on),[_c('QlikObject',_vm._b({},'QlikObject',_vm.$props,false))],1)]}}])},[_vm._v(" "+_vm._s(_vm.objectDescription)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }